import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_formData from "AppQuries/utils/http_formData";

const getAllContractPolicies = async ({ companyCode, isTrue = true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllContractPolicy}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`,
  );
  return data;
};

const getAllContractVariables = async () => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllContractVariables}`,
  );
  return data;
};

const getContractPolicyById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetContractPolicy}?CompanyCode=${companyCode}&Id=${code}`,
  );
  return data;
};

const getGeneratedContract = async ({ companyCode, employeeCode }) => {
  if (!companyCode || !employeeCode) return null;

  const { data } = await http_payroll.get(
    `${Api_EndPoints.GenerateContractPolicy}?CompanyCode=${companyCode}&EmployeeCode=${employeeCode}`,
  );
  return data;
};

const insertContractPolicy = async (input) => {
  const { data } = await http_formData.post(
    Api_EndPoints.InsertandUpdateContractPolicy,
    input,
  );
  return data;
};

const updateContractPolicy = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.InsertandUpdateContractPolicy,
    input,
  );
  return data;
};

// const deleteContractPolicy = async ({ companyCode, code }) => {
//   const { data } = await http_payroll.delete(
//     `${Api_EndPoints.ContractPolicy}?CompanyCode=${companyCode}&Code=${code}`
//   );
//   return data;
// };

export const useGetContractPoliciesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllContractPolicy],
    queryFn: () => getAllContractPolicies(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetContractVariablesQuery = () => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllContractVariables],
    queryFn: () => getAllContractVariables(),
    refetchOnWindowFocus: false,
  });
};

export const useGetContractPolicyByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetContractPolicy],
    queryFn: () => getContractPolicyById(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetGeneratedContractQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GenerateContractPolicy],
    queryFn: () => getGeneratedContract(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertContractPolicyMutation = () => {
  return useMutation({
    mutationFn: insertContractPolicy,
  });
};

export const useUpdateContractPolicyMutation = () => {
  return useMutation({
    mutationFn: updateContractPolicy,
  });
};

// export const useDeleteContractPolicyMutation = () => {
//   return useMutation({
//     mutationFn: deleteContractPolicy,
//   });
// };
